module.exports = {
    test: {
        authApiUrl: '/test',
        emailApiUrl: '/test',
        dbReadHost: 'host',
        dbWriteHost: 'host',
        cforceServiceUrl: 'http://localhost:4000/v1/app',
        appLinkBaseUrl: 'https://apps-test.cmsonline.com',
        docusignOAuthBasePath: 'account-d.docusign.com',
        docusignBasePathURL: 'https://demo.docusign.net',
        underwritingServiceUrl: '/test'
    },
    local: {
        authApiUrl: 'https://api.nexiopaydev.com/auth/v3',
        emailApiUrl: 'https://api.nexiopaydev.com/email/v3',
        dbReadHost: 'ro.nexiopaylocal.com',
        dbWriteHost: 'db.nexiopaylocal.com',
        cforceServiceUrl: 'http://localhost:4000/v1/app',
        appLinkBaseUrl: 'http://localhost:3000',
        docusignOAuthBasePath: 'account-d.docusign.com',
        docusignBasePathURL: 'https://demo.docusign.net',
        underwritingServiceUrl: 'https://api.nexiopaydev.com/underwriting/v3'
    },
    development: {
        authApiUrl: 'https://api.nexiopaydev.com/auth/v3',
        emailApiUrl: 'https://api.nexiopaydev.com/email/v3',
        dbReadHost: 'ro.nexiopaydev.com',
        dbWriteHost: 'db.nexiopaydev.com',
        cforceServiceUrl: 'https://api.nexiopaydev.com/onlineapp/v1/app',
        appLinkBaseUrl: 'https://onlineapp.nexiopaydev.com',
        docusignOAuthBasePath: 'account-d.docusign.com',
        docusignBasePathURL: 'https://demo.docusign.net',
        underwritingServiceUrl: 'https://api.nexiopaydev.com/underwriting/v3'
    },
    staging: {
        authApiUrl: 'https://api.nexiopaystaging.com/auth/v3',
        emailApiUrl: 'https://api.nexiopaystaging.com/email/v3',
        dbReadHost: 'ro.nexiopaystaging.com',
        dbWriteHost: 'db.nexiopaystaging.com',
        cforceServiceUrl: 'https://api.nexiopaystaging.com/onlineapp/v1/app',
        appLinkBaseUrl: 'https://onlineapp.nexiopaystaging.com',
        docusignOAuthBasePath: 'account.docusign.com',
        docusignBasePathURL: 'https://www.docusign.net',
        underwritingServiceUrl: 'https://api.nexiopaystaging.com/underwriting/v3'
    },
    production: {
        authApiUrl: 'https://api.cmsonline.com/auth/v3',
        emailApiUrl: 'https://api.cmsonline.com/email/v3',
        dbReadHost: 'ro.cmsonline.com',
        dbWriteHost: 'db.cmsonline.com',
        cforceServiceUrl: 'https://api.cmsonline.com/onlineapp/v1/app',
        appLinkBaseUrl: 'https://onlineapp.cmsonline.com',
        docusignOAuthBasePath: 'account.docusign.com',
        docusignBasePathURL: 'https://www.docusign.net',
        underwritingServiceUrl: 'https://api.nexiopay.com/underwriting/v3'
    },
    sandbox: {
        authApiUrl: 'https://api.nexiopaysandbox.com/auth/v3',
        emailApiUrl: 'https://api.nexiopaysandbox.com/email/v3',
        dbReadHost: 'ro.nexiopaysandbox.com',
        dbWriteHost: 'db.nexiopaysandbox.com',
        cforceServiceUrl: 'https://api.nexiopaysandbox.com/onlineapp/v1/app',
        appLinkBaseUrl: 'https://onlineapp.nexiopay.com',
        docusignOAuthBasePath: 'account-d.docusign.com',
        docusignBasePathURL: 'https://demo.docusign.net',
        underwritingServiceUrl: 'https://api.nexiopaysandbox.com/underwriting/v3'
    }
};
